import React from 'react';
import Layout from 'components/Layout';
import HeadContent from 'components/HeadContent';
import Books from 'components/Books';

function action({ store, params }) {
  const title = 'Authors';
  const { locationState } = store.getState().router;
  return {
    chunks: ['books'],
    navigation: {
      heading: 'Authors',
      section: 'Books',
      left: null,
      right: null,
    },
    component: (
      <Layout type="full" withLeaderboardAd={false} withFooterLeaderboardAd={false}>
        <HeadContent
          contents={{
            title,
          }}
        />
        <Books
          initialItem={locationState.initialItem || 0}
          shelfStates={locationState || {}}
          tab="authors"
          orderShelvesBy={params.orderBy}
          orderShelvesByDirection={params.orderByDirection}
        />
      </Layout>
    ),
  };
}

export default action;
